// Global
window.lib = null; // NFC Instance
window.interval = null;

require('./bootstrap');